var path = 'app/scripts/modules/oracle/serverGroup/configure/wizard/capacity/capacity.html';
var html = "<div class=\"clearfix\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <oracle-bmcs-server-group-capacity-selector command=\"command\"></oracle-bmcs-server-group-capacity-selector>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/oracle/serverGroup/configure/wizard/capacity/capacity.html
// module id = 1712
// module chunks = 0